import { Trophy, Star, Sparkles } from "lucide-react";

/**
 * AuthBenefits - Shows benefits of signing up
 */
const benefits = [
  { icon: Trophy, text: "Earn points for every review" },
  { icon: Star, text: "Level up and unlock badges" },
  { icon: Sparkles, text: "Get recognized as a top contributor" },
];

export default function AuthBenefits() {
  return (
    <div className="space-y-3 mb-6">
      {benefits.map(({ icon: Icon, text }) => (
        <div key={text} className="flex items-center gap-3">
          <div className="w-8 h-8 bg-brand/10 rounded-lg flex items-center justify-center">
            <Icon className="w-4 h-4 text-brand" />
          </div>
          <span className="text-sm text-gray-700">{text}</span>
        </div>
      ))}
    </div>
  );
}
